import { render, staticRenderFns } from "./getDetail.vue?vue&type=template&id=6d95c41a&scoped=true"
import script from "./getDetail.vue?vue&type=script&lang=js"
export * from "./getDetail.vue?vue&type=script&lang=js"
import style0 from "./getDetail.vue?vue&type=style&index=0&id=6d95c41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95c41a",
  null
  
)

export default component.exports